import React from "react";
import { Grid, Box } from "@mui/material";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";
import { sessionService } from "redux-react-session";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { resendVerification } from "../../redux/actions";
import {
  continueDashboard,
  expiredLinkMsg,
  expiredLinkSubMsg,
  linkAlreadyVerifiedMsg,
  passwordLinkExpired,
  passwordLinkExpiredSubMsg,
  resend,
  resettingPassword,
} from "../messages";
import Button from "../button/Button";
import { linkAlreadySubText } from "../constants";
import Text from "../text/Text";

const LinkStatus = ({ from, type, ...props }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleVerifyEmail = () => {
    if (type === "used") {
      sessionService.deleteUser();
      navigate("/");
    } else if (type === "expired") {
      dispatch(resendVerification({ email: props.email }));
    }
  };

  const handleResetPassword = () => {
    sessionService.deleteUser();
    navigate("/forgot-password");
  };

  let title = "";
  let text = "";
  let actionButton = null;

  const checkLinkType = () => {
    if (type === "expired") {
      title = expiredLinkMsg;
      text = expiredLinkSubMsg;
      actionButton = (
        <Button
          label={resend}
          fullWidth
          className="mt-24"
          onClick={handleVerifyEmail}
          variant="contained"
        />
      );
    } else {
      title = linkAlreadyVerifiedMsg;
      text = linkAlreadySubText(props.email);
      actionButton = (
        <Button
          label={continueDashboard}
          fullWidth
          className="mt-24"
          onClick={handleVerifyEmail}
          variant="contained"
        />
      );
    }
  };

  switch (from) {
    case "verifyEmail":
      checkLinkType();
      break;
    case "resetPassword":
      title = passwordLinkExpired;
      text = passwordLinkExpiredSubMsg;
      actionButton = (
        <Button
          label={resettingPassword}
          fullWidth
          className="mt-24"
          onClick={handleResetPassword}
          variant="contained"
        />
      );
      break;
    case "confirmEmail":
      checkLinkType();
      break;
  }

  return (
    <Box display="flex" justifyContent="center">
      <Grid container alignItems="center" flexDirection="column">
        {type === "used" &&
        (from === "verifyEmail" || from === "confirmEmail") ? (
          <CheckCircleIcon
            style={{
              color: "#2ecc71",
              height: "62px",
              width: "62px",
            }}
          />
        ) : (
          <Box className="expire-icon-box">
            <ReportProblemRoundedIcon
              sx={{ height: "59px", width: "60px", color: "#e74c3c" }}
            />
          </Box>
        )}
        <Text className="default-text mt-24" size={22} font="bold">
          {title}
        </Text>
        <Text className="grey-text mt-8" size={14} align="center">
          {text}
        </Text>
        {actionButton}
      </Grid>
    </Box>
  );
};

export default LinkStatus;
